var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkopen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "current"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4605_17855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18C22.3674 18 22.2402 18.0527 22.1464 18.1464C22.0527 18.2402 22 18.3674 22 18.5V22H10V10H13.5C13.6326 10 13.7598 9.94732 13.8536 9.85355C13.9473 9.75979 14 9.63261 14 9.5C14 9.36739 13.9473 9.24021 13.8536 9.14645C13.7598 9.05268 13.6326 9 13.5 9H9.5C9.36739 9 9.24021 9.05268 9.14645 9.14645C9.05268 9.24021 9 9.36739 9 9.5V22.5C9 22.6326 9.05268 22.7598 9.14645 22.8536C9.24021 22.9473 9.36739 23 9.5 23H22.5C22.6326 23 22.7598 22.9473 22.8536 22.8536C22.9473 22.7598 23 22.6326 23 22.5V18.5C23 18.3674 22.9473 18.2402 22.8536 18.1464C22.7598 18.0527 22.6326 18 22.5 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0029 9.31046C22.9513 9.18889 22.8545 9.0921 22.7329 9.04045C22.6704 9.02558 22.6054 9.02558 22.5429 9.04045H17.5429C17.4103 9.04045 17.2831 9.09313 17.1893 9.1869C17.0956 9.28067 17.0429 9.40785 17.0429 9.54045C17.0429 9.67306 17.0956 9.80024 17.1893 9.89401C17.2831 9.98778 17.4103 10.0405 17.5429 10.0405H21.3329L16.1829 15.1905C16.0907 15.2856 16.0391 15.4129 16.0391 15.5455C16.0391 15.678 16.0907 15.8053 16.1829 15.9005C16.2306 15.9465 16.287 15.9826 16.3488 16.0066C16.4106 16.0307 16.4766 16.0422 16.5429 16.0405C16.6076 16.0414 16.6718 16.0295 16.7319 16.0055C16.792 15.9814 16.8467 15.9457 16.8929 15.9005L22.0029 10.7105V14.5005C22.0029 14.6331 22.0556 14.7602 22.1493 14.854C22.2431 14.9478 22.3703 15.0005 22.5029 15.0005C22.6355 15.0005 22.7627 14.9478 22.8565 14.854C22.9502 14.7602 23.0029 14.6331 23.0029 14.5005V9.50045C23.0178 9.438 23.0178 9.37291 23.0029 9.31046Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4605_17855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkopen);
export default __webpack_public_path__ + "static/media/linkopen.8862c6791dcd94c010c6dcd82418e304.svg";
export { ForwardRef as ReactComponent };